import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../../core/modules/common/components/Button';
import Modal from '../../../core/modules/common/components/Modal';

// eslint-disable-next-line react/prefer-stateless-function
class WarningAsyncReportModal extends Component {
  render() {
    const {
      onCloseModal,
      headerFormattedMessageId,
      length,
    } = this.props;

    return (
      <Modal
        header={
          <FormattedMessage
            id={headerFormattedMessageId}
            values={{ totals: length }}
            tagName="h5"
          />
        }
        closeOnOutsideClick
        onClose={this.props.onCloseModal}
      >
        <div className="operator-form">
          <div className="button-container">
            <Button
              text="app.button.close"
              onClick={onCloseModal}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

WarningAsyncReportModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  headerFormattedMessageId: PropTypes.string.isRequired,
  length: PropTypes.number,
};

export default (WarningAsyncReportModal);
